// 退货详情
import React, { Component, Fragment } from 'react'

import { Input, InputNumber, List, Button, message} from 'antd'


import LiItem from '../commo/LiItem'

import { returnApply, getMerchantInfo } from '_src/api/api'

import '../style/returnDetail.less'
import '../../../common/style/common.less'


class ReturnDetail extends Component {
  constructor (props) {
    super(props)
    const { realPrice } = props.record
    this.realPrice = (realPrice/100).toFixed(2)
    this.status = null
    this.state = {
      returnRefundForm: {
        amount: this.realPrice
      },
      totalPrice: 0,
      param: {}
    }
  }
  componentDidMount () {
    this.setMerchantInfo()
  }

  setMerchantInfo () {
    getMerchantInfo()
      .then(res=>{
        const { data } = res
        const { storeName, mobile, returnAddress } = data
        this.setState((preState)=>({
          returnRefundForm: {...preState.returnRefundForm, name: storeName, tel: mobile, addressDetail: returnAddress}
        }))
      })
  }

  handleNumberChange (key, value) {
    this.setState((preState)=>({
      returnRefundForm: {...preState.returnRefundForm, [key]: value}
    }))
  }
  handleTextChange (key, e) {
    const { target } = e
    const value = target.value
    this.setState((preState)=>({
      param: {...preState.param, [key]: value}
    }))
  }
  handleSubmit = (status) => {
    const realPrice = this.realPrice   
    let { param, returnRefundForm } = this.state
    const { amount } = returnRefundForm

    const { id } = this.props.record
    if (status === 2) {
      if (amount > realPrice) {
        message.error('退款金额不能大于订单金额', 1.5)
        return 
      }
      if (amount < 0) {
        message.error('退款金额不能小于零', 1.5)
        return 
      }
      param = {...param, returnRefundForm: {...returnRefundForm, amount: amount*100}}
    }
    const hide = message.loading('请稍后...')
    returnApply(id, status, param)
      .then(()=>{
        const { onApply } = this.props
        hide()
        onApply()
      })
      .catch(()=>{
        hide()
        message.error('操作失败', 1.5)
      })
  }
  
  render () {
    const { returnRefundForm } = this.state
    const { record } = this.props
    const { status } = record
    let returnStatus = null
    if (status === 1) {
      returnStatus = 2
    }
    if (status === 2) {
      returnStatus = 4
    }
    return (
      <Fragment>
        <div style = {{marginTop: 20}}>
          <List
            header={<div>退货处理</div>}
            bordered
          >  
            <List.Item style = {{padding: 0, width: '100%'}}>
              <LiItem Item = {{title: '联系人', content: returnRefundForm.name}} />
            </List.Item>
            <List.Item style = {{padding: 0, width: '100%'}}>
              <LiItem Item = {{title: '联系方式', content: returnRefundForm.tel}} />
            </List.Item>
            <List.Item style = {{padding: 0, width: '100%'}}>
              <LiItem Item = {{title: '收货地址', content: returnRefundForm.addressDetail}} />
            </List.Item>
            <List.Item style = {{padding: 0, width: '100%'}}>
              {
                status === 1
                  ?<LiItem Item = {{title: '* 退款金额'}} >
                    <InputNumber placeholder = "请输入退款金额(元)" value = {returnRefundForm.amount} 
                      onChange = {(v)=>{ this.handleNumberChange('amount', v) }}
                    />
                    <span style = {{color: 'red', marginLeft: 20}} >退款金额退款金额不能大于订单金额</span>
                  </LiItem>
                  :<LiItem Item = {{title: '* 退款金额', content: returnRefundForm.amount}} />

              }
            </List.Item>
            <List.Item style = {{padding: 0, width: '100%'}}>
              <LiItem Item = {{title: '备注'}} >
                <Input placeholder = "请输入备注" onChange = {(e) => { this.handleTextChange('remark', e) }} />
              </LiItem>
            </List.Item>                
          </List>
        </div>
        <div style = {{marginTop: 30, textAlign: 'right'}}>
          {
            status === 1
              ? <Fragment>
                <Button type = "primary" onClick = {()=>{ this.handleSubmit(returnStatus) }}>确定退货</Button>
                <Button style = {{marginLeft: 30}} type = "danger" onClick = {()=>{ this.handleSubmit(3) }}>拒接退货</Button>
              </Fragment>
              :<Button type = "primary" onClick = {()=>{ this.handleSubmit(returnStatus) }}>确定退款</Button>
          }
        </div>
      </Fragment>   
    )
  }
}


export default ReturnDetail